export function getNationalityId(nationOptions, keyword) {
    if (!keyword || !nationOptions?.length) return null;
    const matched = nationOptions.find(item =>
        item.label.startsWith(keyword)
    );
    return matched?.id || null;
}
export function parseChineseAddress(address) {
    if (!address) return null;

    // 增强版正则表达式，保持原有字段名
    const pattern = /^(.*?(?:省|自治区|直辖市))(.*?(?:市|自治州|地区))?(.*?(?:[市区县]|自治县|旗|盟))(.*?(?:[街道镇乡]|苏木|民族乡))(.*?(?:[村社区]|居委会|村委会))?/;
    const match = address.match(pattern);

    if (!match) return null;

    // 处理直辖市情况（北京、上海、天津、重庆）
    const isDirectCity = ['北京市', '上海市', '天津市', '重庆市'].includes(match[1]);

    return {
        province: match[1],
        city: isDirectCity ? match[1] : (match[2] || ''), // 保持city字段
        county: match[3], // 保持county字段（实际可能是区）
        town: match[4],   // 保持town字段（实际可能是街道）
        village: match[5] || '' // 保持village字段（实际可能是社区）
    };
}